import { ColumnProps } from "@wit/mpesa-ui-components/lib/components/table/table.component";
import { TFunction } from "i18next";
import React from "react";
import { ExternalServicePermitionsEnum, IExternalServices } from "../../../shared/models/service-manager.model";

/** Configurations Utils */
export const getExternalServicesColumns = (t: TFunction): ColumnProps[] => {
  return [
    {
      formKey: "serviceId",
      label: t("pages.externalServices.configurations.columns.serviceId"),
      isEditable: false,
      ratio: 1 / 6,
      changeFunction: (content: string, row: IExternalServices) => {
        let pin = false;
        let ident = false;

        if (row.permissions !== undefined) {
          ident = row.permissions.includes(ExternalServicePermitionsEnum.IDENTITY);
          pin = row.permissions.includes(ExternalServicePermitionsEnum.PIN);
        }

        if (ident) {
          return <div style={{ color: "#6338eb" }}>{content}</div>;
        } else {
          if (pin) {
            return <div style={{ color: "#00c3ff" }}>{content}</div>;
          } else {
            return <div>{row.serviceId}</div>;
          }
        }
      },
    },
    {
      formKey: "url",
      label: t("pages.externalServices.configurations.columns.url"),
      isEditable: true,
      ratio: 3 / 6,
    },
    {
      formKey: "permissions",
      label: t("pages.externalServices.configurations.columns.permissions"),
      isEditable: true,
      ratio: 1 / 6,
      changeFunction: (content: string) => {
        let pin = false;
        let ident = false;

        if (content) {
          ident = content.includes(ExternalServicePermitionsEnum.IDENTITY);
          pin = content.includes(ExternalServicePermitionsEnum.PIN);
        }

        if (ident) {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ color: "#6338eb" }}>
                {t("pages.externalServices.configurations.columns.permissionIDENTITY")}
              </div>
              <div style={{ color: "#6338eb" }} hidden={!pin}>
                ,
              </div>
              <div style={{ color: "#00c3ff", marginLeft: "5px" }} hidden={!pin}>
                {t("pages.externalServices.configurations.columns.permissionPIN")}
              </div>
            </div>
          );
        } else {
          if (pin) {
            return (
              <div style={{ color: "#00c3ff" }}>{t("pages.externalServices.configurations.columns.permissionPIN")}</div>
            );
          } else {
            return <div>-</div>;
          }
        }
      },
    },
  ];
};
